import { type PropsWithChildren, type ReactNode, type SyntheticEvent } from 'react';

import styles from './TooltipContent.css';

export function TooltipContent({
  onClick,
  testId,
  children,
}: PropsWithChildren<{ testId?: string; onClick?: (e: SyntheticEvent) => void }>): ReactNode {
  return (
    <div className={styles['content']} data-testid={testId} onClick={onClick}>
      {children}
    </div>
  );
}

TooltipContent.Description = function TooltipContentDescription({ children }: PropsWithChildren): ReactNode {
  return <div className={styles['description']}>{children}</div>;
};

TooltipContent.List = function TooltipContentList({ children }: PropsWithChildren): ReactNode {
  return <ul className={styles['list']}>{children}</ul>;
};

TooltipContent.ListItem = function TooltipContentListItem({ children }: PropsWithChildren): ReactNode {
  return <li className={styles['list-item']}>{children}</li>;
};
